import BaseStore from "../../../App/Data/Store/BaseStore";
import Undo      from "../../../Lib/Objects/Undo";
import Palettes  from "./Palettes";

export default class Swatches extends BaseStore {

    module = ['Palettes'];
    paletteId;

    constructor(paletteId) {
        super();
        this.paletteId = paletteId;
    }

    reorder(oldIndex, newIndex) {
        this.commit('reorderSwatches', {oldIndex, newIndex, paletteId: this.paletteId});
        window.Broadcast.$emit('swatchesReordered');
    }

    push(swatch) {
        this.commit('pushSwatch', {swatch, paletteId: this.paletteId});
    }

    remove(swatchIndex) {
        let paletteId      = this.paletteId;
        let swatches       = new Palettes().getPaletteById(paletteId).swatches;
        let deletingSwatch = swatches[swatchIndex];

        this.commit('removeSwatch', {swatchIndex, paletteId});

        new Undo('Swatch Deleted')
            .onTimerDone(() => {
            })
            .onUndo(() => {
                this.push(deletingSwatch);
                this.reorder(swatches.length - 1, swatchIndex);
            });
    }

    setColor(swatchIndex, color) {
        this.commit('setSwatchColor', {paletteId: this.paletteId, swatchIndex, color});
    }

}
